import type { JobSearchResult, PaginatedApiResponse } from 'types';
import { baseQuery } from '../baseQuery';

export const jobFilters = ['all', 'un-invoiced', 'cancelled', 'open', 'completed'] as const;
export type JobFilters = (typeof jobFilters)[number];

type JobSearchParams = {
  page?: number;
  recordsPerPage?: number;
  filter?: JobFilters | JobFilters[];
  technicianID?: number | string;
  customerID?: number | string;
  userID?: number | string;
  jobID?: number | string;
  createdFrom?: string; // YYYY-MM-DD
  createdTo?: string; // YYYY-MM-DD
};

export const getJobSearchWithFilters = async ({
  page,
  recordsPerPage,
  filter = 'all',
  technicianID,
  customerID,
  userID,
  jobID,
  createdFrom,
  createdTo,
}: JobSearchParams) => {
  const params = new URLSearchParams();

  // base params
  params.set('page', String(page ?? 1));
  params.set('per_page', String(recordsPerPage ?? 5));

  // filters
  const filters = Array.isArray(filter) ? filter : [filter];
  const statuses = filters.filter((filter) => filter !== 'all' && filter !== 'un-invoiced');
  if (statuses.length) {
    params.append('filter[status]', statuses.join(','));
  }
  if (filters.includes('un-invoiced')) {
    params.append('filter[unInvoiced]', '1');
  }

  if (technicianID) params.append('filter[technicianID]', String(technicianID));
  if (customerID) params.append('filter[customerID]', String(customerID));
  if (userID) params.append('filter[userID]', String(userID));
  if (jobID) params.append('filter[jobID]', String(jobID));

  if (createdFrom) params.append('filter[createdFrom]', createdFrom);
  if (createdTo) params.append('filter[createdTo]', createdTo);

  const data: PaginatedApiResponse<{ job: JobSearchResult }[]> = await baseQuery(
    `job-search-with-filters?${params.toString()}`,
  );

  return data;
};
